import themeLight from "@lib/theme/light";
import { InputAdornment, styled } from "@mui/material";
import MuiTextField from "@mui/material/TextField";

const CustomTextField = styled(MuiTextField, {
  shouldForwardProp: (prop) => !["borderColor", "isError"].includes(prop),
})(({ fullWidth, borderColor, isError, theme, multiline }) => ({
  width: fullWidth ? "100%" : "400px",
  height: multiline ? "auto" : "40px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "white",
    "& fieldset": {
      borderColor: isError ? theme.palette.error.main : borderColor,
      borderWidth: isError ? "2px" : "1px",
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.main,
    },
  },
}));

export default function TextField({ startIcon, label, value, onChange, isBlueBorder, ...props }) {
  const borderColor = isBlueBorder
    ? themeLight.palette.primary.light
    : themeLight.palette.grey[500];

  return (
    <CustomTextField
      InputProps={{
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : null,
        style: { height: props.multiline ? "auto" : "40px" },
      }}
      label={label}
      variant="outlined"
      borderColor={borderColor}
      isError={props.isError}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
}
